import Occasion from '@repo/utils/helpers/Occasion';
import Starred from '@repo/utils/models/Starred';
import type { ReduxAction } from '@repo/utils/types';

export function starredReducer(state: Starred = new Starred(), { type, payload }: ReduxAction) {
  switch (type) {
    case 'LOAD_LOCAL_STORE_SUCCEEDED':
      const storedLists = payload.get('groups');
      const storedStarredList = storedLists
        ? storedLists.find(({ slug }) => slug === 'starred')
        : null;

      if (!state.isLoaded && storedStarredList) {
        return state.copyWith({ ids: storedStarredList.contact_ids });
      } else {
        return state;
      }

    case 'FETCH_STARRED_SUCCEEDED':
      return state.copyWith({ ids: payload.response, updated: new Occasion() });

    case 'UPDATE_GROUP_REQUESTED':
    case 'UPDATE_GROUP_SUCCEEDED':
      if (payload.slug !== 'starred') {
        return state;
      }

      return state.copyWith({ ids: payload.memberIDs.toArray() });

    default:
      return state;
  }
}
